import { render, staticRenderFns } from "./PaymentInvoice.vue?vue&type=template&id=ce228ab0&scoped=true&lang=pug&"
import script from "./PaymentInvoice.vue?vue&type=script&lang=ts&"
export * from "./PaymentInvoice.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentInvoice.vue?vue&type=style&index=0&id=ce228ab0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce228ab0",
  null
  
)

export default component.exports